module.exports = __webpack_public_path__ + "img/01.773d82f4.jpg";